import { useContext } from "react";
import { AnalyticsFiltersContext } from "../providers/analytics-filters.provider";

export function useAnalyticsFilters() {
  const context = useContext(AnalyticsFiltersContext);

  if (!context) {
    throw new Error(
      "useAnalyticsFilters must be used within an AnalyticsFiltersProvider",
    );
  }

  return context;
}
